<template>
    <div>
        <b-row class="d-flex align-items-center justify-content-md-between">
            <b-col cols="12" md="6" class="d-md-flex">
                <base-input v-model="filters.search.search_text" prepend-icon="fas fa-search" placeholder="Search" v-on:keydown.enter="searchByFilter()">
                </base-input>
            </b-col>
            <b-col cols="12" md="3" v-if="_gHlp.checkIsCorporateSubscription()">
                <b-button class="float-right px-3 py-2 mb-2 mb-md-0" variant="outline-secondary"
                    @click="$refs.case_filter_drawer.show()">
                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24">
                        <path fill="#73839C"
                        d="M9 5a1 1 0 1 0 0 2 1 1 0 0 0 0-2zM6.17 5a3.001 3.001 0 0 1 5.66 0H19a1 1 0 1 1 0 2h-7.17a3.001 3.001 0 0 1-5.66 0H5a1 1 0 0 1 0-2h1.17zM15 11a1 1 0 1 0 0 2 1 1 0 0 0 0-2zm-2.83 0a3.001 3.001 0 0 1 5.66 0H19a1 1 0 1 1 0 2h-1.17a3.001 3.001 0 0 1-5.66 0H5a1 1 0 1 1 0-2h7.17zM9 17a1 1 0 1 0 0 2 1 1 0 0 0 0-2zm-2.83 0a3.001 3.001 0 0 1 5.66 0H19a1 1 0 1 1 0 2h-7.17a3.001 3.001 0 0 1-5.66 0H5a1 1 0 1 1 0-2h1.17z" />
                    </svg>
                    Filters
                </b-button>
            </b-col>
        </b-row>
        <div class="table-listings">
            <el-table ref="multipleTable" :data="tableData" style="width: 100%" empty-text="No Data" highlight-current-row>
                <el-table-column width="100">
                    <template slot-scope="scope">
                        <el-tooltip content="Send Google Review Link" placement="top">
                            <i class="fab fa-whatsapp" style="cursor: pointer; font-size: 1.5rem; color: green;"
                                @click="sendGoogleReviewLink(scope.row.prod_customer_id)"></i>
                        </el-tooltip>
                        <el-tooltip content="Copy Google Review Link" placement="top">
                            <i class="far fa-copy" style="cursor: pointer; font-size: 1.5rem;  margin-left: 10px;"
                                @click="copyGoogleReviewLink()"></i>
                        </el-tooltip>
                    </template>
                </el-table-column>

                <el-table-column v-if="_gAuth.activeUser('subscription.privileges.scpk_crm_chat_massage',false)" width="90"
                    class-name="icons-chat">
                    <template slot-scope="scope">
                        <MessagingBoxButton :type="'case'" :profile="scope.row.messaging_data" />
                    </template>
                </el-table-column>

                <el-table-column width="150" prop="prod_id">
                    <template #header>
                        <div class="d-flex flex-column">
                        <div>Case ID</div>
                        <div>/Created At</div>
                    </div>
                    </template>
                    <template slot-scope="scope">
                        <div class="font-weight-bold">{{ scope.row.prod_id }}</div>
                        <div>{{ scope.row.prod_created_date | dateFormatString }}</div>
                    </template>
                </el-table-column>

                <el-table-column label="Name/ID" min-width="220" sortable prop="prod_customer_name">
                    <template slot-scope="scope">
                        <el-tooltip effect="dark" placement="right-end">
                            <div slot="content" class="d-flex align-items-center">
                                    <svg xmlns="http://www.w3.org/2000/svg" class="cursor-pointer"
                                        @click.prevent="_gHlp.copyToClipboard(scope.row.prod_customer_name,'<b>Customer Name:</b> {txt} <br>Copied to Clipboard.')" width="14"
                                        height="18" viewBox="0 0 448 512">
                                        <path fill="currentColor"
                                            d="M208 0h124.1C344.8 0 357 5.1 366 14.1L433.9 82c9 9 14.1 21.2 14.1 33.9V336c0 26.5-21.5 48-48 48H208c-26.5 0-48-21.5-48-48V48c0-26.5 21.5-48 48-48zM48 128h80v64H64v256h192v-32h64v48c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V176c0-26.5 21.5-48 48-48z" />
                                    </svg>
                            </div>
                                <p class="top-line text-primary cursor-pointer" @click="$refs.solicitor_case_details_drawer.show(scope.row.prod_id)">{{
                        scope.row.prod_customer_name | formatUserName(20) }}</p>
                        </el-tooltip>

                        <p class="mb-0 bottom-line">{{ scope.row.prod_customer_id }}</p>
                    </template>
                </el-table-column>

                <el-table-column v-if="_gAuth.isAppSas()" label="Officer" width="100" class-name="text-center">
                    <template slot-scope="scope">
                            <b-avatar size="32px" 
                                    v-b-tooltip.hover="_gHlp.getValue(scope.row,'prod_loan_officer_detail.name')"
                                    :text="_gHlp.getUserInitials(_gHlp.getValue(scope.row,'prod_loan_officer_detail.name'))"
                                    v-if="!_gHlp.isEmpty(scope.row.prod_loan_officer_detail)"></b-avatar>
                            <p v-else>-</p>
                        </template>
                </el-table-column>

                <el-table-column v-if="_gAuth.isAppSas()" width="130" class-name="text-center">
                    <template #header>
                        <span class="text-center w-100">SSA</span>
                    </template>
                        <template slot-scope="scope">
                                <b-avatar size="32px" v-b-tooltip.hover="_gHlp.getValue(scope.row,'prod_ssa_detail.name',null)"
                                    :text="_gHlp.getUserInitials(_gHlp.getValue(scope.row,'prod_ssa_detail.name','-'))"
                                    v-if="scope.row.prod_ssa_detail"></b-avatar>
                            <p v-else>-</p>
                        </template>
                </el-table-column>

                <el-table-column v-if="!_gAuth.isAppSas()" width="130" class-name="text-center">
                <template #header>
                    <span class="text-center w-100">Agent</span>
                </template>
                    <template slot-scope="scope">
                            <b-avatar size="32px" v-b-tooltip.hover="scope.row.prod_agent_username"
                                :text="_gHlp.getUserInitials(scope.row.prod_agent_username)"
                                v-if="scope.row.prod_agent_username"></b-avatar>
                        <p v-else>-</p>
                    </template>
                </el-table-column>

                <el-table-column prop="created_by" label="Created By" width="120" class-name="text-center">
                <template slot-scope="scope">
                    <el-tooltip v-if="scope.row.prod_created_by_detail" placement="bottom" effect="dark">
                        <div slot="content">
                            Name: {{ scope.row.prod_created_by_detail.name }}
                        </div>
                        <b-avatar size="32px"
                            :text="_gHlp.getUserInitials(scope.row.prod_created_by_detail.name)"></b-avatar>
                    </el-tooltip>
                    <div v-else>
                        <span style="font-size: 1.5rem">-</span>
                    </div>
                </template>
                </el-table-column>

                <el-table-column
                    min-width="130"
                    width="auto"
                    class-name="text-center"
                >
                    <template #header>
                        <span class="text-center w-100">TAT</span>
                    </template>
                    <template slot-scope="scope">
                    <el-popover
                            v-if="!_gHlp.isEmpty(scope.row.tat_summary) && !_gHlp.isEmpty(scope.row.tat_summary.tat_at)"
                            placement="top-start"
                            title="Date Tracking"
                            trigger="hover">
                            <p v-if="_gHlp.isEmpty(scope.row.tat_summary.tat_stop_at)">
                                <small class="mb-0 d-block">Last Update : {{scope.row.tat_summary.tat_at | dateFormatString}}</small>
                                <small class="mb-0 d-block" :style="{'color': scope.row.tat_summary.tat_color}">Due Date : {{scope.row.tat_summary.due_at | dateFormatString}}</small>
                                <small class="mb-0 d-block" :style="{'color': scope.row.tat_summary.tat_color}">{{scope.row.tat_summary.remain_label}}</small>
                            </p>
                            <p v-else>
                                <small class="mb-0 d-block">Create Date : {{scope.row.tat_summary.tat_created_at | dateFormatString}}</small>
                                <small class="mb-0 d-block">Stop Date : {{scope.row.tat_summary.tat_stop_at | dateFormatString}}</small>
                                <small class="mb-0 d-block"><strong>TOTAL : {{scope.row.tat_summary.tat_total}} Days</strong></small>
                            </p>
                            <b-avatar :style="{'background-color': scope.row.tat_summary.tat_color, 'color': 'black'}" size="32px" slot="reference">{{ _gHlp.isEmpty(scope.row.tat_summary.tat_stop_at) ? scope.row.tat_summary.remain_day : scope.row.tat_summary.tat_total }}</b-avatar>
                        </el-popover>
                    </template>
                </el-table-column>


                <el-table-column
                    label="Sub Status"
                    width="180"
                >
                    <template slot-scope="scope">
                        {{ scope.row.prod_status }}
                    </template>
                </el-table-column>

                <el-table-column
                    label="Product Type"
                    min-width="180"
                >
                    <template slot-scope="scope">
                        <span v-if="scope.row.product_detail">{{ scope.row.product_detail.prod_sol_type }}</span>
                    </template>
                </el-table-column>

                <el-table-column
                    label="SPA amount"
                    min-width="150"
                >
                    <template slot-scope="scope">
                        <p v-if="scope.row.product_detail">RM{{ scope.row.product_detail.prod_sol_spa_amount | moneyFormatter }}</p>
                    </template>
                </el-table-column>
            </el-table>
        </div>

        <div class="col-12 d-flex justify-content-center justify-content-md-between flex-wrap card-footer">
            <div class="d-flex align-items-center mb-3">
                <p class="card-category mb-0 text-secondary">
                    Showing {{ tablePagination.from }} to {{ tablePagination.to }} of {{ tablePagination.total }} entries

                    <!-- <span v-if="selectedRows.length">
                        &nbsp; &nbsp; {{selectedRows.length}} rows selected
                    </span> -->
                </p>

                <span class="mb-0 ml-4">Rows:</span>

                <el-select
                    class="select-primary pagination-select mx-2"
                    v-model="tablePagination.perPage"
                    placeholder="Per page"
                >
                    <el-option
                        class="select-primary"
                        v-for="item in tablePagination.perPageOptions"
                        :key="item"
                        :label="item"
                        :value="item"
                    >
                    </el-option>
                </el-select>

            </div>
            <base-pagination
                class="pagination-no-border"
                :value="tablePagination.currentPage"
                :per-page="tablePagination.perPage"
                :total="tablePagination.total"
                @change="paginationChanged($event)"
            >
            </base-pagination>
        </div>

        <SolicitorCaseDetailsDrawer ref="solicitor_case_details_drawer"/>
        <FilterDrawer ref="case_filter_drawer" :tableFilters="tableFilters" @onFilter="onFilter($event)" />
    </div>
</template>

<script>
import { Table, TableColumn, Select, Option, Button, Tooltip, Popover } from 'element-ui'
import { BasePagination } from '@/components'
import SolicitorCaseDetailsDrawer from '@/views/CustomerProfile/CustomerProfileDetails/CenterProfileDetails/CasesCards/SolicitorCase/SolicitorCaseDetails/SolicitorCaseDetailsDrawer.vue'
import FilterDrawer from '@/views/Cases/Drawers/FilterDrawer'
import { mapActions, mapState } from 'pinia'
import { useCustomerStore } from '@/stores/customerStore'
import { useProductStore } from '@/stores/productStore'
import MessagingBoxButton from '@/views/Messaging/MessagingBoxButton'
import {
    axios,
    services,
    getHeader,
} from '@/assets/js/httpImports.js'

export default {
    props:['tableData','tablePagination','tableSummary','tableFilters'],
    components: {
        MessagingBoxButton,
        BasePagination,
        SolicitorCaseDetailsDrawer,
        FilterDrawer,
        [Table.name]: Table,
        [TableColumn.name]: TableColumn,
        [Select.name]: Select,
        [Option.name]: Option,
        [Button.name]: Button,
        [Tooltip.name]: Tooltip,
        [Popover.name]: Popover,
    },
    data() {
        return {
            propsToSearch:['prod_customer_name', 'prod_agent_username', 'prod_id'],
            isFixed: true,
            selectedRows: [],
            filters:{
            page:1,
            paginate:25,
            search:{
                search_text:''
            }
            }
        }
    },

    computed: {
        ...mapState(useProductStore, ['current_tab_type']),
    },

    watch:{
        tableFilters:{
            handler(newVal){
                this.filters = {...this.filters, ...newVal};
            },
            immediate: true
        },
    },

    mounted() {
        this.qp_prod_id = this.$route.query.prod_id;
		this.qp_tab = this.$route.query.prod_type;
        if(this.qp_prod_id && this.qp_tab && this.qp_tab == 'solicitor')
		{
			this.$refs.solicitor_case_details_drawer.show(this.qp_prod_id);
		}
    },
    methods: {
        ...mapActions(useCustomerStore, ['getCustomerSimple']),
        async sendGoogleReviewLink(prodCustomerId) {
            try {
                const customer = await this.getCustomerSimple(prodCustomerId);
                const contactNumber = customer.contact_no;
                if (contactNumber) {
                    const corporateId = _gAuth.activeCorporateId();
                    const response = await axios.get(services.access_control + 'corporate/' + corporateId, { headers: getHeader() });
                    const corporateDetail = response.data.data;
                    const formattedContactNumber = contactNumber.replace(/[-()+]/g, '');
                    const mobileNumber = encodeURIComponent(formattedContactNumber);
                    const reviewLink = encodeURIComponent(corporateDetail.review_link);
                    const whatsappLink = `https://wa.me/${mobileNumber}?text=Help%20us%20review%20at%20google%20review%20link%20here%20%3A%20${reviewLink}`;
                    window.open(whatsappLink, '_blank');
                    } else {
                    _gNotif.notifyError('Customer mobile number is not available.');
                }
            } catch (error) {
                _gNotif.notifyError('Error sending Google review link:', error);
            }
        },

        async copyGoogleReviewLink() {
            try {
                const corporateId = _gAuth.activeCorporateId();
                const response = await axios.get(services.access_control + 'corporate/' + corporateId, { headers: getHeader() });
                const corporateDetail = response.data.data;
                const reviewLink = corporateDetail.review_link;
                if (reviewLink) {
                    _gHlp.copyToClipboard(reviewLink,'<b>Google Review Link:</b> {txt} <br>Copied to Clipboard.')
                } else {
                    _gNotif.notifyError('Review link not available for the customer.');
                }
            } catch (error) {
                _gNotif.notifyError('Error copying Google review link:', error);
            }
        },

        onFilter(event) {
            this.filters = {...this.filters,...event}
            this.$emit('onFilter',this.filters);
        },
        searchByFilter(){
            this.filters.page = 1;
            this.filters.is_reset_summary = false;
            this.$emit('onFilter',this.filters)
        },
        paginationChanged(page) {
            this.filters.page = page
            this.onFilter(this.filters)
        },
        setFixed() {
            this.isFixed = window.innerWidth > 768;
        }
    }
}
</script>